import { Pipe, PipeTransform } from '@angular/core';
import { PortalPermission } from 'src/app/core/permissions/portal-permission';

@Pipe({
  name: 'permission',
})
export class PermissionPipe implements PipeTransform {
  constructor(private permission: PortalPermission) {}
  transform(value: string, module: string): boolean {
    const method = {
      add: 'canAdd',
      delete: 'canDelete',
      edit: 'canEdit',
      view: 'canView',
    };

    return this.permission[method[value]](module);
  }
}
